module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_6.12f070b3.pdf";